var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [
          _c(
            "w-card",
            [
              _c(
                "w-card-title",
                [
                  _vm._v(
                    " " + _vm._s(_vm.$ct("standard-to-print-lines")) + " "
                  ),
                  _c("w-spacer"),
                  _c(
                    "w-dropdown",
                    {
                      attrs: {
                        right: "",
                        "use-link": "",
                        items: _vm.extraActions,
                      },
                      on: {
                        click: function ($event) {
                          return $event()
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "ellipsis-v" } })],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-card-content",
                [
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("app-custom-language-select", {
                            model: {
                              value: _vm.selectedLanguage,
                              callback: function ($$v) {
                                _vm.selectedLanguage = $$v
                              },
                              expression: "selectedLanguage",
                            },
                          }),
                        ],
                        1
                      ),
                      _c("w-tabs", {
                        style: { width: "100%" },
                        attrs: { tabs: _vm.tabs },
                        model: {
                          value: _vm.tab,
                          callback: function ($$v) {
                            _vm.tab = $$v
                          },
                          expression: "tab",
                        },
                      }),
                      _vm.tab == 0
                        ? _c(
                            "w-row",
                            { staticClass: "mt", style: { maxWidth: "100%" } },
                            [
                              _c(
                                "w-col",
                                { attrs: { xs: "12" } },
                                [
                                  _vm.canPrintOgm
                                    ? _c("w-input", {
                                        attrs: {
                                          disabled: !_vm.lines.PrintOgm,
                                          label: _vm.$ct("ogm-text"),
                                          value: _vm.ogmText,
                                          fancy: "",
                                        },
                                        on: {
                                          blur: function ($event) {
                                            return _vm.onOgmTextBlur()
                                          },
                                          focus: function ($event) {
                                            _vm.ogmTextFocused = true
                                          },
                                          input: function ($event) {
                                            return _vm.setOgmText($event)
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _c(
                                "w-col",
                                { attrs: { xs: "12" } },
                                [
                                  _c("w-input", {
                                    attrs: {
                                      label: _vm.$ct("totalExcVAT"),
                                      fancy: "",
                                    },
                                    model: {
                                      value:
                                        _vm.lines.TotalExcVAT.Translations[
                                          _vm.selectedLanguage
                                        ],
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.lines.TotalExcVAT.Translations,
                                          _vm.selectedLanguage,
                                          $$v
                                        )
                                      },
                                      expression:
                                        "lines.TotalExcVAT.Translations[selectedLanguage]",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "w-col",
                                { attrs: { xs: "12" } },
                                [
                                  _c("w-input", {
                                    attrs: {
                                      label: _vm.$ct("base"),
                                      fancy: "",
                                    },
                                    model: {
                                      value:
                                        _vm.lines.TotalBase.Translations[
                                          _vm.selectedLanguage
                                        ],
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.lines.TotalBase.Translations,
                                          _vm.selectedLanguage,
                                          $$v
                                        )
                                      },
                                      expression:
                                        "lines.TotalBase.Translations[selectedLanguage]",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "w-col",
                                { attrs: { xs: "12" } },
                                [
                                  _c("w-input", {
                                    attrs: { label: _vm.$ct("VAT"), fancy: "" },
                                    model: {
                                      value:
                                        _vm.lines.VAT.Translations[
                                          _vm.selectedLanguage
                                        ],
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.lines.VAT.Translations,
                                          _vm.selectedLanguage,
                                          $$v
                                        )
                                      },
                                      expression:
                                        "lines.VAT.Translations[selectedLanguage]",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "w-col",
                                { attrs: { xs: "12" } },
                                [
                                  _c("w-input", {
                                    attrs: {
                                      label: _vm.$ct("totalVAT"),
                                      fancy: "",
                                    },
                                    model: {
                                      value:
                                        _vm.lines.TotalVAT.Translations[
                                          _vm.selectedLanguage
                                        ],
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.lines.TotalVAT.Translations,
                                          _vm.selectedLanguage,
                                          $$v
                                        )
                                      },
                                      expression:
                                        "lines.TotalVAT.Translations[selectedLanguage]",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "w-col",
                                { attrs: { xs: "12" } },
                                [
                                  _c("w-input", {
                                    attrs: {
                                      label: _vm.$ct("beforeToPay"),
                                      fancy: "",
                                    },
                                    model: {
                                      value:
                                        _vm.lines.TotalToPayBefore.Translations[
                                          _vm.selectedLanguage
                                        ],
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.lines.TotalToPayBefore
                                            .Translations,
                                          _vm.selectedLanguage,
                                          $$v
                                        )
                                      },
                                      expression:
                                        "lines.TotalToPayBefore.Translations[selectedLanguage]",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "w-col",
                                { attrs: { xs: "12" } },
                                [
                                  _c("w-input", {
                                    attrs: {
                                      label: _vm.$ct("validTil"),
                                      fancy: "",
                                    },
                                    model: {
                                      value:
                                        _vm.lines.OfferValidTil.Translations[
                                          _vm.selectedLanguage
                                        ],
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.lines.OfferValidTil.Translations,
                                          _vm.selectedLanguage,
                                          $$v
                                        )
                                      },
                                      expression:
                                        "lines.OfferValidTil.Translations[selectedLanguage]",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "w-col",
                                { attrs: { xs: "12" } },
                                [
                                  _c("w-input", {
                                    attrs: {
                                      label: _vm.$ct("beforeTotal"),
                                      fancy: "",
                                    },
                                    model: {
                                      value:
                                        _vm.lines.Total.Translations[
                                          _vm.selectedLanguage
                                        ],
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.lines.Total.Translations,
                                          _vm.selectedLanguage,
                                          $$v
                                        )
                                      },
                                      expression:
                                        "lines.Total.Translations[selectedLanguage]",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "w-col",
                                { attrs: { xs: "12" } },
                                [
                                  _c("w-input", {
                                    attrs: {
                                      label: _vm.$ct("payed"),
                                      fancy: "",
                                    },
                                    model: {
                                      value:
                                        _vm.lines.PayedRecently.Translations[
                                          _vm.selectedLanguage
                                        ],
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.lines.PayedRecently.Translations,
                                          _vm.selectedLanguage,
                                          $$v
                                        )
                                      },
                                      expression:
                                        "lines.PayedRecently.Translations[selectedLanguage]",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "w-col",
                                { attrs: { xs: "12" } },
                                [
                                  _c("w-input", {
                                    attrs: {
                                      label: _vm.$ct("discountApplied"),
                                      fancy: "",
                                    },
                                    model: {
                                      value:
                                        _vm.lines.DiscountApplied.Translations[
                                          _vm.selectedLanguage
                                        ],
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.lines.DiscountApplied
                                            .Translations,
                                          _vm.selectedLanguage,
                                          $$v
                                        )
                                      },
                                      expression:
                                        "lines.DiscountApplied.Translations[selectedLanguage]",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "w-col",
                                { attrs: { xs: "12" } },
                                [
                                  _c("w-input", {
                                    attrs: {
                                      label: _vm.$ct("discountExclVatApplied"),
                                      fancy: "",
                                    },
                                    model: {
                                      value:
                                        _vm.lines.DiscountExclVatApplied
                                          .Translations[_vm.selectedLanguage],
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.lines.DiscountExclVatApplied
                                            .Translations,
                                          _vm.selectedLanguage,
                                          $$v
                                        )
                                      },
                                      expression:
                                        "lines.DiscountExclVatApplied.Translations[selectedLanguage]",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "w-col",
                                { attrs: { xs: "12" } },
                                [
                                  _c("w-input", {
                                    attrs: {
                                      label: _vm.$ct("toPay"),
                                      fancy: "",
                                    },
                                    model: {
                                      value:
                                        _vm.lines.ToPayAmount.Translations[
                                          _vm.selectedLanguage
                                        ],
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.lines.ToPayAmount.Translations,
                                          _vm.selectedLanguage,
                                          $$v
                                        )
                                      },
                                      expression:
                                        "lines.ToPayAmount.Translations[selectedLanguage]",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "w-col",
                                { attrs: { xs: "12" } },
                                [
                                  _c("w-input", {
                                    attrs: {
                                      label: _vm.$ct(
                                        "payment-before-discount-date-conditions"
                                      ),
                                      fancy: "",
                                    },
                                    model: {
                                      value:
                                        _vm.lines
                                          .PaymentBeforeDiscountDateConditions
                                          .Translations[_vm.selectedLanguage],
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.lines
                                            .PaymentBeforeDiscountDateConditions
                                            .Translations,
                                          _vm.selectedLanguage,
                                          $$v
                                        )
                                      },
                                      expression:
                                        "lines.PaymentBeforeDiscountDateConditions.Translations[selectedLanguage]",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "w-col",
                                { attrs: { xs: "12" } },
                                [
                                  _c("w-input", {
                                    attrs: {
                                      label: _vm.$ct("tax-leeggoed"),
                                      fancy: "",
                                    },
                                    model: {
                                      value:
                                        _vm.lines.LeeggoedText.Translations[
                                          _vm.selectedLanguage
                                        ],
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.lines.LeeggoedText.Translations,
                                          _vm.selectedLanguage,
                                          $$v
                                        )
                                      },
                                      expression:
                                        "lines.LeeggoedText.Translations[selectedLanguage]",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.tab == 1
                        ? _c(
                            "w-row",
                            { staticClass: "mt", style: { maxWidth: "100%" } },
                            [
                              _c(
                                "w-col",
                                { attrs: { xs: "12" } },
                                [
                                  _c("w-checkbox", {
                                    attrs: {
                                      value: !_vm.lines.HideDiscount,
                                      label: _vm.$ct(
                                        "show-total-lines.discount"
                                      ),
                                    },
                                    on: {
                                      input: function ($event) {
                                        _vm.lines.HideDiscount = !$event
                                      },
                                    },
                                  }),
                                  _c("w-checkbox", {
                                    attrs: {
                                      label: _vm.$ct(
                                        "show-total-lines.discount-excl-vat"
                                      ),
                                    },
                                    model: {
                                      value: _vm.lines.ShowDiscountExclVat,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.lines,
                                          "ShowDiscountExclVat",
                                          $$v
                                        )
                                      },
                                      expression: "lines.ShowDiscountExclVat",
                                    },
                                  }),
                                  _c("w-checkbox", {
                                    attrs: {
                                      label: _vm.$ct(
                                        "show-total-lines.also-show-negative-discount"
                                      ),
                                    },
                                    model: {
                                      value:
                                        _vm.lines.AlsoShowNegativeDiscounts,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.lines,
                                          "AlsoShowNegativeDiscounts",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "lines.AlsoShowNegativeDiscounts",
                                    },
                                  }),
                                  _c("w-checkbox", {
                                    attrs: {
                                      value: !_vm.lines.HideToPrintMessage,
                                      label: _vm.$ct(
                                        "show-total-lines.to-print-message"
                                      ),
                                    },
                                    on: {
                                      input: function ($event) {
                                        _vm.lines.HideToPrintMessage = !$event
                                      },
                                    },
                                  }),
                                  _c("w-checkbox", {
                                    attrs: {
                                      value: !_vm.lines.HideTotalLabels,
                                      label: _vm.$ct(
                                        "show-total-lines.total-labels"
                                      ),
                                    },
                                    on: {
                                      input: function ($event) {
                                        _vm.lines.HideTotalLabels = !$event
                                      },
                                    },
                                  }),
                                  _c("w-checkbox", {
                                    attrs: {
                                      value: !_vm.lines.HideTotalValues,
                                      label: _vm.$ct(
                                        "show-total-lines.total-values"
                                      ),
                                    },
                                    on: {
                                      input: function ($event) {
                                        _vm.lines.HideTotalValues = !$event
                                      },
                                    },
                                  }),
                                  _c("w-checkbox", {
                                    attrs: {
                                      value: !_vm.lines.HideTotalAmount,
                                      label: _vm.$ct(
                                        "show-total-lines.total-values-amount"
                                      ),
                                    },
                                    on: {
                                      input: function ($event) {
                                        _vm.lines.HideTotalAmount = !$event
                                      },
                                    },
                                  }),
                                  _c("w-checkbox", {
                                    attrs: {
                                      label: _vm.$ct(
                                        "show-total-lines.total-totals"
                                      ),
                                    },
                                    model: {
                                      value: _vm.lines.ShowTotalTotals,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.lines,
                                          "ShowTotalTotals",
                                          $$v
                                        )
                                      },
                                      expression: "lines.ShowTotalTotals",
                                    },
                                  }),
                                  _c("w-checkbox", {
                                    attrs: {
                                      value:
                                        !_vm.lines
                                          .HidePaymentBeforeDiscountConditions,
                                      label: _vm.$ct(
                                        "show-total-lines.payment-before-discount-conditions"
                                      ),
                                    },
                                    on: {
                                      input: function ($event) {
                                        _vm.lines.HidePaymentBeforeDiscountConditions =
                                          !$event
                                      },
                                    },
                                  }),
                                  _c("w-checkbox", {
                                    attrs: {
                                      value: !_vm.lines.HidePartlyPaid,
                                      label: _vm.$ct(
                                        "show-total-lines.partly-paid"
                                      ),
                                    },
                                    on: {
                                      input: function ($event) {
                                        _vm.lines.HidePartlyPaid = !$event
                                      },
                                    },
                                  }),
                                  _c("w-checkbox", {
                                    attrs: {
                                      value: !_vm.lines.HideLeftToPay,
                                      label: _vm.$ct(
                                        "show-total-lines.left-to-pay"
                                      ),
                                    },
                                    on: {
                                      input: function ($event) {
                                        _vm.lines.HideLeftToPay = !$event
                                      },
                                    },
                                  }),
                                  _c("w-checkbox", {
                                    attrs: {
                                      value: !_vm.lines.HideCurrency,
                                      label: _vm.$ct(
                                        "show-total-lines.currency"
                                      ),
                                    },
                                    on: {
                                      input: function ($event) {
                                        _vm.lines.HideCurrency = !$event
                                      },
                                    },
                                  }),
                                  _c("w-checkbox", {
                                    attrs: {
                                      value: !_vm.lines.HideAll,
                                      label: _vm.$ct(
                                        "show-total-lines.hide-all"
                                      ),
                                    },
                                    on: {
                                      input: function ($event) {
                                        _vm.lines.HideAll = !$event
                                      },
                                    },
                                  }),
                                  _vm.canPrintOgm
                                    ? _c("w-checkbox", {
                                        attrs: { label: _vm.$ct("print-ogm") },
                                        model: {
                                          value: _vm.lines.PrintOgm,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.lines, "PrintOgm", $$v)
                                          },
                                          expression: "lines.PrintOgm",
                                        },
                                      })
                                    : _vm._e(),
                                  _c("w-checkbox", {
                                    attrs: {
                                      label: _vm.$ct("show-fostplus-table"),
                                    },
                                    model: {
                                      value:
                                        _vm.layout.FostplusTableDataSettings
                                          .Show,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.layout.FostplusTableDataSettings,
                                          "Show",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "layout.FostplusTableDataSettings.Show",
                                    },
                                  }),
                                  _c("app-select-placement", {
                                    attrs: {
                                      "include-none": "",
                                      "full-control": "",
                                      disabled: _vm.signaturePlacementDisabled,
                                      layout: _vm.layout,
                                      value: _vm.signaturePlacement,
                                      label: _vm.$ct("signature"),
                                    },
                                    on: {
                                      input: function ($event) {
                                        return _vm.setSignaturePlacement($event)
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.toEditGrandTotalStyle
                ? _c(
                    "w-modal",
                    { attrs: { value: "" } },
                    [
                      _c("app-style-editor", {
                        attrs: { value: _vm.toEditGrandTotalStyle },
                        on: {
                          close: function ($event) {
                            _vm.toEditGrandTotalStyle = null
                          },
                          input: function ($event) {
                            return _vm.onGrandTotalStyle($event)
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.toEditTotalStyle
                ? _c(
                    "w-modal",
                    { attrs: { value: "" } },
                    [
                      _c("app-style-editor", {
                        attrs: { value: _vm.toEditTotalStyle },
                        on: {
                          close: function ($event) {
                            _vm.toEditTotalStyle = null
                          },
                          input: function ($event) {
                            return _vm.onTotalStyle($event)
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }